/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_StartingInputs */

const en_spellcheck_starting = /** @type {(inputs: Spellcheck_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting spell check process... please wait.`)
};

const fr_spellcheck_starting = /** @type {(inputs: Spellcheck_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage de la verification orthographique... veuillez patienter.`)
};

const de_spellcheck_starting = /** @type {(inputs: Spellcheck_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtschreibprüfung wird gestartet... Bitte warten.`)
};

const it_spellcheck_starting = /** @type {(inputs: Spellcheck_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio del controllo ortografico... attendere.`)
};

const ru_spellcheck_starting = /** @type {(inputs: Spellcheck_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запуск процесса проверки орфографии... пожалуйста, подождите.`)
};

const es_spellcheck_starting = /** @type {(inputs: Spellcheck_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando el proceso de revisión ortográfica... por favor espere.`)
};

const zh_cn2_spellcheck_starting = /** @type {(inputs: Spellcheck_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在启动拼写检查……请稍候。`)
};

const ja_spellcheck_starting = /** @type {(inputs: Spellcheck_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペルチェックプロセスを開始しています...お待ちください。`)
};

const hi_spellcheck_starting = /** @type {(inputs: Spellcheck_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तनी जांच प्रक्रिया शुरू हो रही है... कृपया प्रतीक्षा करें।`)
};

const pt_pt2_spellcheck_starting = /** @type {(inputs: Spellcheck_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando o processo de verificação ortográfica... aguarde.`)
};

/**
* | output |
* | --- |
* | "Starting spell check process... please wait." |
*
* @param {Spellcheck_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_starting = /** @type {((inputs?: Spellcheck_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_starting(inputs)
	if (locale === "de") return de_spellcheck_starting(inputs)
	if (locale === "it") return it_spellcheck_starting(inputs)
	if (locale === "ru") return ru_spellcheck_starting(inputs)
	if (locale === "es") return es_spellcheck_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_starting(inputs)
	if (locale === "ja") return ja_spellcheck_starting(inputs)
	if (locale === "hi") return hi_spellcheck_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_starting(inputs)
	return en_spellcheck_starting(inputs)
});